import { makeAutoObservable } from 'mobx'

import { EditObjectDraftRevision } from 'shared/api/kyrgyzstan/edit-object'

export class EditObjectStore {
  objectId: string | null = null

  sourceDraftId: string | null = null

  draft: EditObjectDraftRevision | null = null

  isDirty = false

  constructor() {
    makeAutoObservable(this)
  }

  get draftId() {
    return this.draft?.id ?? null
  }

  getDraftByObjectId = (objectId?: string) => {
    if (this.objectId !== objectId) {
      return null
    }

    return this.draft
  }

  getDraftBySourceDraftId = (sourceDraftId?: string) => {
    if (this.sourceDraftId !== sourceDraftId) {
      return null
    }

    return this.draft
  }

  setObjectDraft = (objectId: string, draft: EditObjectDraftRevision) => {
    const isSameSession =
      this.sourceDraftId === null &&
      this.objectId === objectId &&
      this.draft?.id === draft.id

    this.objectId = objectId
    this.sourceDraftId = null
    this.draft = draft

    if (!isSameSession) {
      this.isDirty = false
    }
  }

  setRejectedDraft = (
    sourceDraftId: string,
    draft: EditObjectDraftRevision,
  ) => {
    const isSameSession =
      this.sourceDraftId === sourceDraftId && this.draft?.id === draft.id

    this.objectId = draft.realty_object_id
    this.sourceDraftId = sourceDraftId
    this.draft = draft

    if (!isSameSession) {
      this.isDirty = false
    }
  }

  markDirty = () => {
    this.isDirty = true
  }

  reset = () => {
    this.objectId = null
    this.sourceDraftId = null
    this.draft = null
    this.isDirty = false
  }
}

export const editObjectSessionStore = new EditObjectStore()
